<template>
  <span>
    <v-row dense justify="center">
      <v-col
        v-for="kpi in listaKpisCardInicial"
        :key="kpi.value"
        cols="auto"
        class="flex-grow-1"
      >
        <v-card class="my-0 elevation-0">
          <v-card-title>
            <v-tooltip bottom v-if="traducaoIndicadores[kpi.value] != null">
              <template v-slot:activator="{ on }">
                <h5 v-on="on">{{ kpi.text }}</h5>
              </template>
              <span>{{ traducaoIndicadores[kpi.value] }}</span>
            </v-tooltip>
            <h5 v-else>{{ kpi.text }}</h5>

            <status-evolucao-kpis
              class="ml-1"
              :valorAtual="dadosKpisTotalizados[kpi.value] || 0"
              :valorAnterior="
                dadosKpisTotalizadosCompetenciaAnterior[kpi.value] || 0
              "
            />
          </v-card-title>
          <div
            v-if="loadingPorChave.kpisTotalizados"
            class="d-flex align-center justify-center"
            style="height: 50px;"
          >
            <v-progress-circular indeterminate color="primary" size="32" />
          </div>
          <v-card-text v-else>
            <div class="display-3">
              {{
                dadosKpisTotalizados[kpi.value]
                  | parseNumberToFloatBrIgnoringNaN
              }}
              <span>{{ kpi.suffix }}</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row dense class="mt-1">
      <v-col cols="12">
        <dashboard-servicos-visao-aneel-card-situacao-solicitacoes
          :dados="dadosSituacoesSolicitacoes"
          :exportingOptions="exportingOptions"
          :loading="loadingPorChave.situacaoSolicitacoes"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12">
        <dashboard-servicos-visao-aneel-card-pendentes
          :dados="dadosCardPendentes"
          :competencias="categories"
          :prazoReguladoServico="prazoReguladoServico"
          :exportingOptions="exportingOptions"
          :loading="loadingPorChave.cardPendentes"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12">
        <dashboard-servicos-visao-aneel-card-concluidas
          :dados="dadosCardConcluidas"
          :competencias="categories"
          :prazoReguladoServico="prazoReguladoServico"
          :exportingOptions="exportingOptions"
          :loading="loadingPorChave.cardConcluidas"
        />
      </v-col>
    </v-row>

    <dashboard-servicos-visao-aneel-cards-kpis-por-competencia
      :dados="dadosCardsKpisPorCompetencia"
      :categories="categories"
      :metasKpis="metasKpis"
      :exportingOptions="exportingOptions"
      :loading="loadingPorChave.cardsKpisPorCompetencia"
    />
  </span>
</template>

<script>
  import DashboardServicosService from "@/services/DashboardServicosService";
  import IndicadoresServicosV2Service from "@/services/IndicadoresServicosV2Service";

  import Highcharts from "highcharts";
  import HighchartsNoData from "highcharts/modules/no-data-to-display";
  HighchartsNoData(Highcharts);

  import dayjs from "dayjs";

  export default {
    name: "DashboardServicosVisaoAneel",
    components: {
      StatusEvolucaoKpis: () =>
        import("@/components/dashboardLno/StatusEvolucaoKpis.vue"),
      DashboardServicosVisaoAneelCardSituacaoSolicitacoes: () =>
        import(
          "@/components/dashboardServicos/DashboardServicosVisaoAneelCardSituacaoSolicitacoes.vue"
        ),
      DashboardServicosVisaoAneelCardPendentes: () =>
        import(
          "@/components/dashboardServicos/DashboardServicosVisaoAneelCardPendentes.vue"
        ),
      DashboardServicosVisaoAneelCardConcluidas: () =>
        import(
          "@/components/dashboardServicos/DashboardServicosVisaoAneelCardConcluidas.vue"
        ),
      DashboardServicosVisaoAneelCardsKpisPorCompetencia: () =>
        import(
          "@/components/dashboardServicos/DashboardServicosVisaoAneelCardsKpisPorCompetencia.vue"
        ),
    },
    props: {
      competencia: {
        type: String,
        required: true,
      },
      servicosSelecionados: {
        type: Array,
        required: true,
      },
      categories: {
        type: Array,
        required: true,
      },
      activatedTab: {
        type: Number,
        required: true,
      },
      traducaoIndicadores: {
        type: Object,
        default: {},
      },
      regionalSelecionada: {
        type: Number,
        default: 0,
      },
    },
    data: () => ({
      listaKpisCardInicial: [
        { value: "pendentes", text: "Pendentes", suffix: "" },
        { value: "pendentes_no_prazo", text: "Pendentes no Prazo", suffix: "" },
        {
          value: "pendentes_em_atraso",
          text: "Pendentes em Atraso",
          suffix: "",
        },
        { value: "psa", text: "PSA", suffix: "%" },
        { value: "pat", text: "PAT", suffix: "" },
        { value: "suspensos", text: "Suspensos", suffix: "" },
        { value: "concluidos", text: "Concluídos", suffix: "" },
        {
          value: "concluidos_no_prazo",
          text: "Concluídos no Prazo",
          suffix: "",
        },
        {
          value: "concluidos_fora_prazo",
          text: "Concluídos Fora Prazo",
          suffix: "",
        },
        { value: "prazo_medio_total", text: "Prazo Médio Total", suffix: "" },
        { value: "patc", text: "PATC", suffix: "" },
        { value: "solicitacoes", text: "Solicitações", suffix: "" },
        { value: "compensacao", text: "Compensação", suffix: "" },
      ],
      prazoReguladoServico: 0,
      rawPrazoReguladoServico: 0,
      dadosKpisTotalizados: {},
      dadosKpisTotalizadosCompetenciaAnterior: {},
      dadosSituacoesSolicitacoes: {},
      dadosCardPendentes: {},
      dadosCardConcluidas: {},
      dadosCardsKpisPorCompetencia: {},
      metasKpis: {},
      exportingOptions: {
        enabled: true,
        buttons: {
          contextButton: {
            align: "left",
            verticalAlign: "bottom",
            menuItems: [
              {
                textKey: "downloadPNG",
                text: "Baixar como PNG",
                onclick: function() {
                  this.exportChart();
                },
              },
              {
                separator: true,
              },
              {
                textKey: "downloadCSV",
                text: "Baixar como CSV",
                onclick: function() {
                  this.downloadCSV();
                },
              },
              {
                textKey: "downloadXLS",
                text: "Baixar como XLS",
                onclick: function() {
                  this.downloadXLS();
                },
              },
            ],
          },
        },
      },
      loadingPorChave: {
        kpisTotalizados: false,
        kpisTotalizadosAnterior: false,
        metasKpis: false,
        situacaoSolicitacoes: false,
        cardPendentes: false,
        cardConcluidas: false,
        cardsKpisPorCompetencia: false,
      },
      isFetching: false,
    }),
    computed: {
      competenciaDe() {
        return dayjs(this.categories[0], "MM/YYYY").format("YYYY-MM");
      },
      competenciaAte() {
        return this.competencia;
      },
      competenciaAnterior() {
        return dayjs(this.competencia)
          .subtract(1, "month")
          .format("YYYY-MM");
      },
    },
    async mounted() {
      await this.getPrazoReguladoServico();
      this.getDados();
    },
    methods: {
      finalizarLoadingDados() {
        this.$emit("updateLoadingDadosTable", false);
        this.isFetching = false;
      },
      scheduleGetDados() {
        this.getDados();
      },
      getPrazoReguladoServico() {
        // Apenas atualiza os se for a visao selecionada
        if (this.activatedTab !== 2) return;

        // Apenas carrega prazo se houver selecionado 1 serviço
        if (this.servicosSelecionados.length !== 1) {
          this.prazoReguladoServico = this.rawPrazoReguladoServico = null;
          return;
        }

        return IndicadoresServicosV2Service.getPrazoReguladoServico(
          this.servicosSelecionados[0],
        )
          .then((res) => {
            this.prazoReguladoServico = Number(res.prazo_regulado);
            this.rawPrazoReguladoServico = res.prazo_regulado_raw;
          })
          .catch((err) => {
            this.$toast.error(
              "Erro ao recuperar Prazo Regulado do serviço selecionado.",
              "",
              {
                position: "topRight",
              },
            );
            throw err;
          });
      },
      getDados() {
        if (this.activatedTab !== 2) {
          this.finalizarLoadingDados();
          return;
        }
        if (this.servicosSelecionados.length === 0) {
          this.finalizarLoadingDados();
          return;
        }
        if (this.isFetching) {
          return;
        }

        this.isFetching = true;
        this.$emit("updateLoadingDadosTable", true);

        const promises = [
          this.getDadosKpisTotalizados(),
          this.getDadosKpisTotalizadosCompetenciaAnterior(),
          this.getMetasKpisGeral(),
          this.getDadosSituacaoSolicitacoes(),
          this.getDadosCardPendentes(),
          this.getDadosCardConcluidas(),
          this.getDadosCardsKpisPorCompetencia(),
        ];

        Promise.allSettled(promises)
          .then((results) => {
            const hasError = results.some((r) => r.status === "rejected");
            if (hasError) {
              this.$toast.error("Erro ao recuperar parte dos dados.", "", {
                position: "topRight",
              });
            }
          })
          .finally(() => {
            this.finalizarLoadingDados();
          });
      },
      getDadosKpisTotalizados() {
        this.loadingPorChave.kpisTotalizados = true;
        return DashboardServicosService.getDadosKpisTotalizadosVisaoAneel(
          this.competencia,
          this.competencia,
          this.servicosSelecionados,
          this.regionalSelecionada,
        )
          .then((res) => {
            this.dadosKpisTotalizados = res;
          })
          .finally(() => {
            this.loadingPorChave.kpisTotalizados = false;
          });
      },
      getDadosKpisTotalizadosCompetenciaAnterior() {
        this.loadingPorChave.kpisTotalizadosAnterior = true;
        return DashboardServicosService.getDadosKpisTotalizadosVisaoAneel(
          this.competenciaAnterior,
          this.competenciaAnterior,
          this.servicosSelecionados,
          this.regionalSelecionada,
        )
          .then((res) => {
            this.dadosKpisTotalizadosCompetenciaAnterior = res;
          })
          .finally(() => {
            this.loadingPorChave.kpisTotalizadosAnterior = false;
          });
      },
      getMetasKpisGeral() {
        this.loadingPorChave.metasKpis = true;
        return DashboardServicosService.getMetasKpisGeral(
          "2023-01",
          dayjs().format("YYYY-MM"),
          this.servicosSelecionados,
        )
          .then((res) => {
            this.metasKpis = res;
          })
          .finally(() => {
            this.loadingPorChave.metasKpis = false;
          });
      },
      getDadosSituacaoSolicitacoes() {
        this.loadingPorChave.situacaoSolicitacoes = true;
        return DashboardServicosService.getDadosSituacaoSolicitacoes(
          this.competencia,
          this.competencia,
          this.servicosSelecionados,
          this.regionalSelecionada,
        )
          .then((res) => {
            this.dadosSituacoesSolicitacoes = res;
          })
          .finally(() => {
            this.loadingPorChave.situacaoSolicitacoes = false;
          });
      },
      getDadosCardPendentes() {
        this.loadingPorChave.cardPendentes = true;
        return DashboardServicosService.getDadosCardPendentes(
          this.competenciaDe,
          this.competenciaAte,
          this.servicosSelecionados,
          this.regionalSelecionada,
        )
          .then((res) => {
            this.dadosCardPendentes = res;
          })
          .finally(() => {
            this.loadingPorChave.cardPendentes = false;
          });
      },
      getDadosCardConcluidas() {
        this.loadingPorChave.cardConcluidas = true;
        return DashboardServicosService.getDadosCardConcluidas(
          this.competenciaDe,
          this.competenciaAte,
          this.servicosSelecionados,
          this.regionalSelecionada,
        )
          .then((res) => {
            this.dadosCardConcluidas = res;
          })
          .finally(() => {
            this.loadingPorChave.cardConcluidas = false;
          });
      },
      getDadosCardsKpisPorCompetencia() {
        this.loadingPorChave.cardsKpisPorCompetencia = true;
        return DashboardServicosService.getDadosCardsKpisPorCompetencia(
          this.competenciaDe,
          this.competenciaAte,
          this.servicosSelecionados,
          this.regionalSelecionada,
        )
          .then((res) => {
            this.dadosCardsKpisPorCompetencia = res;
          })
          .finally(() => {
            this.loadingPorChave.cardsKpisPorCompetencia = false;
          });
      },
    },
    watch: {
      activatedTab() {
        this.scheduleGetDados();
      },
      competencia() {
        this.scheduleGetDados();
      },
      async servicosSelecionados() {
        await this.getPrazoReguladoServico();
        this.scheduleGetDados();
      },
      regionalSelecionada() {
        this.scheduleGetDados();
      },
    },
  };
</script>

<style></style>
